import styled from 'styled-components';

const StyledFooter = styled.footer`
  width: 100%;
  background-color: ${props => props.theme.footerBg};
  border-top: 1px solid ${props => props.theme.borderPrimary};
  padding: 1rem 1.5rem;
  margin-top: auto;
  flex-shrink: 0;
  transition: ${props => props.theme.transition};
  
  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  gap: 0.5rem;
  
  @media (max-width: 640px) {
    font-size: 0.625rem;
    gap: 0.25rem;
  }
`;

const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 1;
  
  @media (max-width: 640px) {
    gap: 0.25rem;
  }
`;

const FooterLink = styled.a`
  color: ${props => props.theme.textMuted};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: ${props => props.theme.textPrimary};
  }
`;

const Separator = styled.span`
  color: ${props => props.theme.borderSecondary};
  
  @media (max-width: 640px) {
    margin: 0 0.125rem;
  }
`;

const PoweredByContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.textMuted};
  flex-shrink: 0;
  white-space: nowrap;
  margin-right: 3em;
`;

const BrandName = styled.span`
  font-weight: 600;
  color: ${props => props.theme.textMuted};
  margin-left: 0.25rem;
  
  @media (max-width: 640px) {
    margin-left: 0.125rem;
  }
`;

function Footer({localizedText, chosenLanguage}) {
    let localTranslations = localizedText?.find(localText => localText.ProjectId === Number.parseInt(chosenLanguage));

    return (
        <StyledFooter>
            <FooterContent>
                <LinksContainer>
                    {localTranslations?.Trademarks && localTranslations?.TrademarksLink && (
                        <>
                            <FooterLink 
                                href={"https://onrsurveys.app/tos"}
                                target='_blank'
                                rel="noopener noreferrer"
                            >
                                {'Terms of Service'}
                            </FooterLink>
                            <Separator>|</Separator>
                        </>
                    )}
                    <FooterLink 
                        href={localTranslations?.PrivacyLink || "https://onrsurveys.app/privacy"}
                        target='_blank'
                        rel="noopener noreferrer"
                    >
                        {localTranslations?.Privacy || 'Privacy'}
                    </FooterLink>
                </LinksContainer>
                
                <PoweredByContainer>
                    <span>Powered by</span>
                    <BrandName>ONRSurveys</BrandName>
                </PoweredByContainer>
            </FooterContent>
        </StyledFooter>
    );
}

export default Footer;